import { REDUCER_KEY_RS } from '@Pages/RetroSynthesis/RetroSynthesisProjects/constants';
import { REDUCER_KEY_RS_BREADCRUMBS } from '@Pages/RetroSynthesis/RsBreadcrumbs/constants';
import isUndefined from 'lodash/isUndefined';

const getRsState = (state) => state && state.get && state.get(REDUCER_KEY_RS);
const getRsBreadcrumbsData = (state) => getRsState(state)?.get(REDUCER_KEY_RS_BREADCRUMBS);

export const getProjectsInfoMap = (state) => getRsBreadcrumbsData(state)?.projectsInfoMap || {};
export const getRemovedProjectIds = (state) => getRsBreadcrumbsData(state)?.removedProjectIds;
export const getRemovedRouteIds = (state) => getRsBreadcrumbsData(state)?.removedRouteIds;
export const getProjectsCount = (state) => getRsBreadcrumbsData(state)?.projectsCount;
export const getHasProjects = (state) => {
  const { projectsCount } = getRsBreadcrumbsData(state) || {};
  return !isUndefined(projectsCount) ? projectsCount > 0 : undefined;
};
